import React from 'react'
import styled from 'styled-components'
import { useMenuContext } from '../../state'
import { useScrollFreeze } from '../../hooks'
import NavLinks from './NavLinks'
import mobileBg from '../../assets/images/mobile-bg-green.svg'

const MobileNavbar = () => {
  const { isMenuOpen } = useMenuContext()
  useScrollFreeze(isMenuOpen)
  return (
    <div>
      {isMenuOpen && (
        <MobileNav>
          <NavLinks />
        </MobileNav>
      )}
    </div>
  )
}

export default MobileNavbar

const MobileNav = styled.nav`
  position: fixed;
  top: 0;
  left: 0;
  overflow-y: auto;
  height: 100%;
  width: 100%;
  background: var(--background0);
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  z-index: 2;
  background-image: url('${mobileBg}');
  background-position: bottom;
  background-repeat: no-repeat;
`
